Wee.fn.make('gallery', {
	init: function() {
		var priv = this.$private,
			$items = $('ref:galleryItem');

		// Render gallery item
		Wee.$set('requestUrl', '/media/item/');
		Wee.$set('renderView', 'lightbox');

		// Click events
		$items.data('index', function(i) {
			return i;
		}).on('click.gallery', function(e, el) {
			var $el = $(el),
				index = $el.data('index');
			priv.loadTarget(index);
		});
	},
	unload: function() {
		Wee.events.off(false, '.gallery');

		if (Wee.app.gallery) {
			Wee.app.gallery.$destroy();
		}
	}
}, {

	/**
	 * Generate the gallery item detail structure on initial event
	 */
	createTarget: function() {
		var scope = this;
		scope.$item = $('<div class="lightbox" />');

		scope.$item.appendTo('ref:gallery');

		$.app.make('gallery', {
			view: Wee.$get('renderView'),
			target: scope.$item
		});

		var $prev = $('ref:lightboxPrev'),
			$next = $('ref:lightboxNext'),
			$close = $('ref:lightboxClose');

		$prev.on('click.gallery', function() {
			scope.navigate();
		});

		$next.on('click.gallery', function() {
			scope.navigate(true);
		});

		$close.on('click.gallery', function() {
			scope.close();
		});

		$($._body).on('keydown.gallery', function(e) {
			if (e.keyCode == 37) {
				// Keyboard next (right arrow key)
				scope.navigate();
			} else if (e.keyCode == 39) {
				// Keyboard previous (left arrow key)
				scope.navigate(true);
			} else if (e.keyCode == 27) {
				// Keyboard close (escape key)
				scope.close();
			}
		});
	},

	/**
	 * Load gallery item data from server
	 *
	 * @param {int} index
	 */
	loadTarget: function(index) {
		var scope = this,
			$item = $('ref:galleryItem').eq(index);
		scope.index = index;

		var id = $item.attr('data-id');

		if (! Wee.app.gallery) {
			scope.createTarget();
		}

		$('ref:lightboxMedia').removeClass('-is-loaded');

		Wee.data.request({
			url: Wee.$get('requestUrl') + id,
			json: true,
			success: function(data) {
				scope.renderTarget(data);
			}
		});
	},

	/**
	 * Render the gallery item data into the application
	 *
	 * @param {object} data
	 */
	renderTarget: function(data) {
		Wee.app.gallery.$set(data);

		this.$item.removeClass('-is-loading');
		this.$item.show();
		$('ref:lightboxMedia').addClass('-is-loaded');
	},

	/**
	 * Move forward or backwards through the gallery
	 *
	 * @param bool (next=false) default
	 */
	navigate: function(next) {
		var $gallery = $('ref:galleryItem'),
			total = $gallery.length,
			index = 0;

		if (next) {
			index = this.index + 1 < total ? this.index + 1 : 0;
		} else {
			index = ! this.index ? total - 1 : this.index - 1;
		}

		this.loadTarget(index);
	},

	/**
	 * Close the currently open gallery item detail
	 */
	close: function() {
		this.$item.hide();
	}
});